import React from 'react';

// 58px tinted circle wrapping a centered icon — the badge shared by the gate /
// confirmation subscription modals (AdminGateModal, ApplicationSubmittedModal).
//
// NOTE: ApprovalModal and TrialWelcomeModal deliberately use a DIFFERENT badge
// (a solid-fill octicon disc) and must not be switched to this one — unifying
// them previously caused a rendering bug because var(--fgColor-onEmphasis) is
// undefined in the Civic Lens @primer/react-brand context. See ApprovalModal.
//
// The background hex is intentionally inline for now; it folds into the broader
// hardcoded-hex → token cleanup tracked in the remaining-work doc.
//
// Props: { icon: <Octicon component>, iconSize = 26 }
export default function IconCircleBadge({ icon: Icon, iconSize = 26 }) {
  return (
    <div
      style={{
        width: 58,
        height: 58,
        borderRadius: '50%',
        background: '#ddeeff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon size={iconSize} fill="var(--fgColor-accent)" />
    </div>
  );
}
